// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import type { Country } from '@alphaott/api-client/types/countries'
import type { CountriesNormalize } from '@alphaott/common-types/normalized'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import { defaultToEmptyObject } from '@alphaott/common-utils/utils/help'
import countriesListSchema from '@alphaott/common-utils/utils/schemas/countries'
import { FETCH_TVSHOW_COUNTRIES } from '../../actions/tvshowCountries'

export type TVShowCountriesState = {|
  isLoading: boolean,
  isSuccess: boolean,
  isError: boolean,
  errors: any,
  data: Array<Country>,
  entities: CountriesNormalize,
  expires: ?number,
|}

const initialState: TVShowCountriesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  entities: {},
  expires: null,
}

const tvshowCountries = typeToReducer(
  {
    [FETCH_TVSHOW_COUNTRIES]: {
      LOADING: (state): TVShowCountriesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): TVShowCountriesState => {
        const {
          payload,
          meta: { ttl },
        } = action
        const { entities } = normalize(payload.data, countriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          entities: defaultToEmptyObject(entities.countries),
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): TVShowCountriesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { tvshowCountries }
